import yup from 'utils/yup';

export const initialEvvSettingData = {
  evv_sync_event: null as any,
  evv_provider: null as any,
  evv_data_provider: null as any,
  timezone: null as any,
};

export const evvSettingValidation = yup.object().shape({
  evv_sync_event: yup.string().required(),
  evv_provider: yup.string().required(),
});
